import { render, staticRenderFns } from "./OrderInvoicesTab.vue?vue&type=template&id=77dc765d&scoped=true&"
import script from "./OrderInvoicesTab.vue?vue&type=script&lang=js&"
export * from "./OrderInvoicesTab.vue?vue&type=script&lang=js&"
import style0 from "./OrderInvoicesTab.vue?vue&type=style&index=0&id=77dc765d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dc765d",
  null
  
)

export default component.exports